import React from 'react';
import { TendencyPts } from '../../../Tendency';
import { formatPercent } from "../../../Format";
import { CellTwoLines } from "../../../tables/CellTwoLines";

const OptInRateCell = ({val, refVal}) => {
  return (<CellTwoLines
  text={ isNaN(val) ? "-" : formatPercent(100 * val) }
  subtext={
    <TendencyPts value={100 * val} refValue={100 * refVal}/>
  }/>)
}

export default OptInRateCell

